<template>
  <div class="bigul-login-page">
    <img
      src="https://images.dhan.co/api-partners/stockants.svg"
      alt=""
      class="stockants-logo"
    />
    <div class="top-margin-25 login-form" v-loading="isLoading">
      <div class="top-btm-sec">
        <div>
          <p class="top-text">
            Login to
            {{
              currentEnvironment.utm_source == "Multigain Trade"
                ? "Multigain"
                : currentEnvironment.utm_source == "Share India Trade"
                ? "Share India"
                : currentEnvironment.utm_source == "Ashlar India Trade"
                ? "Ashlar India"
                : currentEnvironment.utm_source
            }}
          </p>
        </div>
      </div>
      <div style="margin-bottom: 35px">
        <div class="input-group-section">
          <div
            class="form-group"
            :class="{
              'not-empty': username.length,
              'form-group--error': show_error_on_empty && $v.username.$error,
            }"
          >
            <el-input
              v-model="username"
              size="small"
              type="text"
              class="form-control"
              placeholder="Client ID"
              name="user"
              @input="setUsername($event)"
            >
            </el-input>
          </div>
          <div
            class="error"
            v-if="show_error_on_empty && !$v.username.required"
          >
            Field is required
          </div>
        </div>

        <div class="input-group-section">
          <div
            class="form-group"
            :class="{
              'not-empty': userPassword.length,
              'form-group--error':
                show_error_on_empty && $v.userPassword.$error,
            }"
            style="margin-bottom: 5px; position: relative"
          >
            <img
              v-if="show_password"
              src="../assets/images/visibility.png"
              class="password-visibility cursor-pointer"
              @click="show_password = !show_password"
            />
            <img
              v-else
              src="../assets/images/eye.png"
              @click="show_password = !show_password"
              class="password-visibility cursor-pointer"
            />

            <el-input
              v-model="userPassword"
              size="small"
              :type="show_password ? 'text' : 'password'"
              class="form-control"
              placeholder="Password"
              name="pass"
              @input="setPassword($event)"
            >
            </el-input>
          </div>
          <div
            class="error"
            v-if="show_error_on_empty && !$v.userPassword.required"
          >
            Field is required
          </div>
        </div>

        <div
          class="input-group-section"
          v-if="currentEnvironment.utm_source == 'Zebu'"
        >
          <div
            class="form-group"
            :class="{
              'not-empty': userBirthYear.length,
              'form-group--error':
                show_error_on_empty && $v.userBirthYear.$error,
            }"
            style="margin-bottom: 5px; position: relative"
          >
            <el-input
              v-model="userBirthYear"
              size="small"
              class="form-control"
              placeholder="Year of Birth"
              name="YOB"
            >
            </el-input>
          </div>
          <div
            class="error"
            v-if="show_error_on_empty && !$v.userBirthYear.required"
          >
            Field is required
          </div>
        </div>

        <div class="input-group-section" v-if="isLoginSuccess">
          <div
            class="form-group"
            :class="{
              'not-empty': verifyPin.length,
              'form-group--error': show_error_on_empty && $v.verifyPin.$error,
            }"
            style="margin-bottom: 5px; position: relative"
          >
            <el-input
              v-model="verifyPin"
              size="small"
              type="text"
              class="form-control"
              :placeholder="
                currentEnvironment.utm_source == 'Maitra Commodities' ||
                currentEnvironment.utm_source == 'Ashlar India Trade' ||
                currentEnvironment.utm_source == 'Tradeplus'
                  ? 'Enter Pin'
                  : 'Enter OTP'
              "
              name="verifyPin"
              @input="setPin($event)"
            >
            </el-input>
          </div>
          <div
            class="error"
            v-if="show_error_on_empty && !$v.verifyPin.required"
          >
            Field is required
          </div>
        </div>

        <div class="input-group-section text-left">
          <!-- <el-checkbox disabled v-model="terms_and_conditions"> </el-checkbox >-->
          <p
            style="font-size: 14px;
                font-weight: 500;
                color: #989595;"
          >
            <i
              class="el-icon-check"
              style="    font-size: 15px;
    background: #4e4fbc;
    color: #ffff;
    font-weight: 600;
    word-break: normal;
"
            ></i>
            User is by default accepting
            <router-link
              to="/retail-side/terms-condition"
              style="color: #2d2e8d"
            >
              terms and conditions
            </router-link>
            of StockAnts
          </p>
        </div>
      </div>

      <!-- <div class="text-center top-margin-20 bottom-margin-20">
                    <el-checkbox v-model="remember_me">
                      Remember password
                    </el-checkbox>
                  </div> -->

      <div
        class="flex-space-between"
        v-if="currentEnvironment.utm_source != 'Zebu'"
      >
        <el-button
          rounded
          class="btn-theme-borderd login-btn"
          size="small"
          style="width: 100%"
          @click="isLoginSuccess ? verifyPinCode() : login()"
        >
          <div v-if="isLoginSuccess">
            {{
              currentEnvironment.utm_source == "Maitra Commodities" ||
              currentEnvironment.utm_source == "Ashlar India Trade" ||
              currentEnvironment.utm_source == "Tradeplus"
                ? "Verify Pin"
                : "Verify OTP"
            }}
          </div>
          <div v-else>
            Login
          </div>
        </el-button>
      </div>
      <div v-if="currentEnvironment.utm_source == 'Zebu'">
        <el-button
          rounded
          class="btn-theme-borderd login-btn"
          size="small"
          style="width: 100%"
          @click="loginZebu()"
        >
          Login
        </el-button>
      </div>

      <div
        class="new-pin-txt"
        v-if="
          isLoginSuccess &&
            (currentEnvironment.utm_source != 'Tradeplus' &&
              currentEnvironment.utm_source != 'Share India Trade')
        "
        @click="generateNewPinCode()"
      >
        Generate New
        {{
          currentEnvironment.utm_source == "Maitra Commodities" ? "Pin" : "OTP"
        }}
      </div>
      <div class="top-btm-sec">
        <img
          :style="[
            currentEnvironment.width ? { width: currentEnvironment.width } : {},
          ]"
          class="finvasia-logo"
          utm_source
          :src="currentEnvironment.utm_source ? currentEnvironment.logo : ''"
          alt=""
        />
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { HelperNetworkCallBack } from "../mixins/Helper";
import { loginNetworkCallBack } from "../mixins/login.NetworkCallback";
import CripNotice from "crip-vue-notice";
import { serverAddr } from "../networkConfig";

export default {
  name: "BigulLoginPage",
  mixins: [HelperNetworkCallBack, loginNetworkCallBack],
  data() {
    return {
      show_password: false,
      show_dob: false,
      username: "",
      userPassword: "",
      userBirthYear: "",
      verifyPin: "",
      show_error_on_empty: false,
      terms_and_conditions: true,
      isLoading: false,
      isLoginSuccess: false,
      currentUrl: localStorage.getItem("currentUrl")
        ? localStorage.getItem("currentUrl")
        : window.location.href,
      brokerId: null,
      currentEnvironment: {},
    };
  },

  watch: {},

  validations: {
    username: {
      required,
    },
    userPassword: {
      required,
    },
    userBirthYear: {
      required,
    },
    verifyPin: {
      required,
    },
  },

  created() {},

  mounted() {
    // <!-- bigul : otp -->
    // <!-- Choice : otp -->
    // <!-- nirnman : pin -->

    if (localStorage.getItem("selected_broker")) {
      this.brokerId = Number(localStorage.getItem("selected_broker"));
    }

    if (localStorage.getItem("currentEnvironment")) {
      this.currentEnvironment = JSON.parse(
        localStorage.getItem("currentEnvironment")
      );
    }
  },

  methods: {
    setUsername(value) {
      this.username = value;
      this.$v.username.$touch();
    },
    setPassword(value) {
      this.userPassword = value;
      this.$v.userPassword.$touch();
    },
    setPin(value) {
      this.verifyPin = value;
      this.$v.verifyPin.$touch();
    },

    login() {
      var currentUrl = window.location.href;
      var apiUrl = "";
      // if (
      //   this.currentEnvironment.utm_source == "Choice" ||
      //   currentUrl.includes("choice.stockants.com")
      // ) {
      //   apiUrl = "/auth/v1/choice/totp_login";
      // } else
      if (
        this.currentEnvironment.utm_source == "Bigul" ||
        currentUrl.includes("bigul.stockants.com")
      ) {
        apiUrl = "/auth/v1/bigul/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "Maitra Commodities" ||
        currentUrl.includes("maitracommodities.stockants.com")
      ) {
        apiUrl = "/auth/v1/maitra/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "Tradeplus" ||
        currentUrl.includes("tradeplus.stockants.com")
      ) {
        apiUrl = "/auth/v1/tradeplus/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "Ashlar India Trade" ||
        currentUrl.includes("ashlarindia-trade.stockants.com")
      ) {
        apiUrl = "/auth/v1/ashlar/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "Share India Trade" ||
        currentUrl.includes("shareindia-trade.stockants.com")
      ) {
        apiUrl = "/auth/v1/share_india/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "Multigain Trade" ||
        currentUrl.includes("multigain-trade.stockants.com")
      ) {
        apiUrl = "/auth/v1/multigain_trade/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "SKI Capital" ||
        currentUrl.includes("skicapital.stockants.com")
      ) {
        apiUrl = "/auth/v1/ski_capital/validate_user";
      } else if (
        this.currentEnvironment.utm_source == "SS Corporate" ||
        currentUrl.includes("sscorp.stockants.com")
      ) {
        apiUrl = "/auth/v1/ss_corporate/validate_user";
      }

      this.show_error_on_empty = true;
      this.$v.$touch();
      if (this.username.trim() && this.userPassword) {
        this.isLoading = true;
        serverAddr
          .post(apiUrl, {
            broker_id: this.brokerId,
            username: this.username,
            password: this.userPassword,
          })
          .then((response) => {
            this.isLoading = false;
            var data = response.data;

            if (data && data.status) {
              this.isLoginSuccess = true;
              this.show_error_on_empty = false;

              // Store the token only for Share India
              if (
                this.currentEnvironment.utm_source == "Share India Trade" ||
                currentUrl.includes("shareindia-trade.stockants.com")
              ) {
                this.token = data.data.token;
              }

              new CripNotice({
                title: "Success",
                description: response.data.validation,
                type: "success",
                duration: 3,
              });
            } else {
              this.username = "";
              this.userPassword = "";
              this.show_error_on_empty = false;
            }
          })
          .catch(
            function(error) {
              if (error) {
                new CripNotice({
                  title: "Oops! Something went wrong!",
                  description: "Try after some time",
                  type: "error",
                  duration: 3,
                });
                this.username = "";
                this.userPassword = "";
                this.show_error_on_empty = false;
                this.isLoading = false;
              }
            }.bind(this)
          );
      }
    },

    verifyPinCode() {
      var apiUrl = "";
      // if (this.currentEnvironment.utm_source == "Choice") {
      //   apiUrl = "/auth/v1/choice/validate_login_user";
      // } else

      var currentUrl = this.currentUrl;
      // console.log("Current URL:", currentUrl);

      if (this.currentEnvironment.utm_source == "Bigul") {
        apiUrl = "/auth/v1/bigul/validate_pin";
      } else if (this.currentEnvironment.utm_source == "Maitra Commodities") {
        apiUrl = "/auth/v1/maitra/validate_pin";
      } else if (this.currentEnvironment.utm_source == "Tradeplus") {
        apiUrl = "/auth/v1/tradeplus/validate_pin";
      } else if (this.currentEnvironment.utm_source == "Ashlar India Trade") {
        apiUrl = "/auth/v1/ashlar/validate_pin";
      } else if (this.currentEnvironment.utm_source == "Share India Trade") {
        apiUrl = "/auth/v1/share_india/validate_pin";
      } else if (this.currentEnvironment.utm_source == "Multigain Trade") {
        apiUrl = "/auth/v1/multigain_trade/validate_pin";
      } else if (this.currentEnvironment.utm_source == "SKI Capital") {
        apiUrl = "/auth/v1/ski_capital/validate_pin";
      } else if (this.currentEnvironment.utm_source == "SS Corporate") {
        apiUrl = "/auth/v1/ss_corporate/validate_pin";
      }
      this.$v.$touch();
      var obj = {
        username: this.username,
        pin: this.verifyPin,
      };

      if (
        (this.currentEnvironment &&
          this.currentEnvironment.utm_source == "Share India Trade") ||
        currentUrl.includes("shareindia-trade.stockants.com")
      ) {
        obj.token = this.token;
      }
      if (this.verifyPin.trim()) {
        this.isLoading = true;
        serverAddr.post(apiUrl, obj).then(this.loginUserNetworkCallBack);
      }
    },
    loginZebu() {
      this.isLoading = true;
      this.show_error_on_empty = true;
      this.$v.$touch();
      if (this.username.trim() && this.userPassword && this.userBirthYear) {
        serverAddr
          .post("/auth/v1/zebu/validate_user_pin", {
            user_id: this.username,
            broker_id: this.brokerId,
            password: this.userPassword,
            factor2: this.userBirthYear,
          })
          .then(this.loginUserNetworkCallBack)
          .catch(
            function(error) {
              this.isLoading = false;
              // if (error) {
              // }
            }.bind(this)
          );
      }
    },
    generateNewPinCode() {
      if (this.currentEnvironment.utm_source == "Choice") {
        this.login();
      } else {
        this.isLoading = true;
        serverAddr
          .post("/trade/v1/regenerate_otp", {
            user_id: this.username,
            broker_id: this.brokerId,
          })
          .then((response) => {
            if (response.data.status) {
              new CripNotice({
                title: "Success",
                description: response.data.validation,
                type: "success",
                duration: 3,
              });
            }
            this.isLoading = false;
          })
          .catch(
            function(error) {
              this.isLoading = false;
              // if (error) {
              // }
            }.bind(this)
          );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bigul-login-page {
  text-align: center;
  margin: 40px auto;

  .stockants-logo {
    width: 280px;
  }

  .new-pin-txt {
    font-size: 12px;
    margin-top: 5px;
    font-weight: 600;
    color: #409eff;
    cursor: pointer;
  }

  .login-form {
    width: 385px;
    margin: 0 auto;
    margin-top: 40px;
    padding: 40px;
    -webkit-box-shadow: 0px 4px 8px 0px #00000033;
    box-shadow: 0px 0px 5px 2px #00000033;
    border-radius: 15px;

    .top-btm-sec {
      text-align: center;
    }

    .finvasia-short-logo {
      width: 75px;
    }

    .finvasia-logo {
      margin-top: 40px;
      width: 180px;
    }

    .password-visibility {
      position: absolute;
      right: 10px;
      top: 15px;
      z-index: 1;
      width: 25px;
    }

    .login-btn {
      width: 100%;
      height: 40px;
      font-size: 18px;
      background-color: #4e4fbc;
      color: #ffff;
      font-weight: 600;
      border: 1px solid;
    }

    .top-text {
      font-size: 22px;
      font-weight: 500;
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 625px) {
    .stockants-logo {
      width: 70%;
    }

    .login-form {
      width: 70%;
      padding: 20px;
      margin-top: 30px;
    }

    .login-form .top-text {
      font-size: 20px;
    }

    .login-form .login-btn {
      height: 40px;
      font-size: 15px;
    }

    .login-form .finvasia-logo {
      margin-top: 25px;
      width: 160px;
    }

    .login-form .finvasia-short-logo {
      width: 50px;
    }
  }
}
</style>
<style lang="scss">
.login-form {
  .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-radius: 0;
    font-size: 16px;
    border: 3px solid #d9d7d7;
    margin-top: 10px;
  }
}

@media screen and (max-width: 625px) {
  .login-form .el-input--small .el-input__inner {
    height: 35px;
    line-height: 35px;
    font-size: 13px;
  }
}
</style>
